const getWebviewEnrollmentUrl = (courseRunKey: string, emailOptIn: boolean) =>
  `edxapp://enroll?course_id=${courseRunKey}&email_opt_in=${emailOptIn}`;

export default getWebviewEnrollmentUrl;
